export default "__VITE_ASSET__BJ8GB8uv__"